import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_pagination = _resolveComponent("el-pagination");
  return _openBlock(), _createBlock(_component_el_pagination, _mergeProps(_ctx.$attrs, {
    background: "",
    "hide-on-single-page": true
  }), null, 16);
}